export default "__VITE_ASSET__7ddd5343__"